var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('app-header'),_c('app-nav'),_c('router-view'),_c('app-footer'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyright"},[_c('a',{attrs:{"href":"http://webgarden.eu","target":"_blank","rel":"noopener noreferrer"}},[_c('img',{attrs:{"src":require("./assets/images/WG_logo.png"),"alt":"WebGarden webdesign"}})])])
}]

export { render, staticRenderFns }